import { Component, OnInit } from "@angular/core";
import { ConfigService } from "../services/config-service.service";

@Component({
  standalone: false,
  selector: "flyht-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  footerYear: number;
  footerVersion: string;

  constructor(public configService: ConfigService) {}

  ngOnInit(): void {
    this.footerYear = new Date().getFullYear();
    this.configService.load().then(() => {
      this.footerVersion = this.configService.getJson().version;
    });
  }
}
